import { useState, useEffect, useCallback } from 'react';
import { useSafeTimeout } from './useSafeTimeout';

const useRefresh = (cb?: () => void) => {
  const [refresh, setRefresh] = useState(false);
  const setSafeTimeout = useSafeTimeout();

  useEffect(() => {
    if (refresh) {
      if (cb) {
        cb();
      }
      setSafeTimeout(() => {
        setRefresh(false);
      }, 0);
    }
  }, [refresh, cb, setSafeTimeout]);

  const triggerRefresh = useCallback(() => {
    setRefresh(true);
  }, []);

  return { refresh, triggerRefresh };
};

export default useRefresh;
